import React from "react";
import { FaFingerprint } from "react-icons/fa";
import { Tab, Nav, Tabs } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { useRef, useState } from "react";
import { useContext } from "react";
import { VideoContext } from "../../videoContext";
import ButtonList from "../ButtonList/ButtonList";
import { Navigation, Autoplay } from 'swiper/modules';

function OurProcess() {

  const videos = [
    {
      id: 1,
      eventKey: 'first',
      step: 'Step 1',
      title: '1',
      url: "https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0",
      name: 'Shaft Length',
      description: 'Determined by an average of static measurements and dynamic testing. Promoting good balance points and optimal ball flight.',
    },
    {
      id: 2,
      eventKey: 'second',
      step: 'Step 2',
      title: '2',
      url: 'https://player.vimeo.com/video/844427479?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Grip size',
      description: 'An average of static measurements and dynamic testing. Promoting a comfortable feel as well as helping achieve a shot pattern.',
    },
    {
      id: 3,
      eventKey: 'third',
      step: 'Step 3',
      title: '3',
      url: 'https://player.vimeo.com/video/844434593?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: ' Sole Design',
      description: 'Dynamic testing to determine the amount of bounce you should have to promote consistent launch, spin, and carry distance. ',
    },
    {
      id: 4,
      eventKey: 'fourth',
      step: 'Step 4',
      title: '4',
      url: 'https://player.vimeo.com/video/844429208?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Lie Angle',
      description: 'Matching up your face to path relationship to produce a consistent and predictable start line and shot shape. ',
    },
    {
      id: 5,
      eventKey: 'fifth',
      step: 'Step 5',
      title: '5',
      url: 'https://player.vimeo.com/video/844436447?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Weight',
      description: 'Dynamic testing to determine what weight your club should be to produce repeatable timing, tempo, and strike location.',
    },
    {
      id: 6,
      eventKey: 'sixth',
      step: 'Step 6',
      title: '6',
      url: 'https://player.vimeo.com/video/844431115?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Shaft Flex',
      description: 'Dynamic testing to determine an ideal flex that promotes consistent strike location and produces optimal launch, spin, distance.',
    },
    {
      id: 7,
      eventKey: 'seventh',
      step: 'Step 7',
      title: '7',
      url: 'https://player.vimeo.com/video/844433856?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Shaft Profile',
      description: 'Dynamic testing to determine where the kick point of the shaft benefits the player to promote consistent strike location and feel.',
    },

  ];

  const { currentPlayingIndex, setCurrentPlayingIndex, handlePlay, playVideo, pauseVideo, playerRefs } = useContext(VideoContext);

  // const playerRefs = useRef([]);
  //    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

  //     const handlePlay = (index) => {
  //         if (currentPlayingIndex !== null) {
  //             // Pause the currently playing video
  //             pauseVideo(currentPlayingIndex);
  //         }

  //         playVideo(index);
  //     };

  //     const playVideo = (index) => {
  //         const player = playerRefs.current[index];
  //         if (player) {
  //             player.contentWindow.postMessage(
  //                 JSON.stringify({
  //                     method: 'play',
  //                     value: null
  //                 }),
  //                 '*'
  //             );

  //             setCurrentPlayingIndex(index);
  //         }
  //     };

  //     const pauseVideo = (index) => {
  //         const player = playerRefs.current[index];
  //         if (player) {
  //             player.contentWindow.postMessage(
  //                 JSON.stringify({
  //                     method: 'pause',
  //                     value: null
  //                 }),
  //                 '*'
  //             );

  //             setCurrentPlayingIndex(null);
  //         }
  //     };

  const tabKeys = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh'];
  const [activeTab, setActiveTab] = useState(tabKeys[0]);



  const handleTabChange = (eventKey) => {
    setActiveTab(eventKey);
  };

  const handleNextTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };

  const handlePrevTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }
  };


  return (
    <>
      <section id="our_process" className="our_process bg_dark page-section pattern_bg_pattern">
        <div className="container-xl">
          <div className="d-flex align-items-center justify-content-between sec_tile_bar">
            <h2 className="sec_title">Our Process:</h2>
            <div className="btn-section hide_mobile">
              <ButtonList subject="club fitting" />
            </div>
          </div>
          <div className="hide_desktop-v2 process_tabs new_process_tabs mobile_process_tabs mb-0">

            <Tabs activeKey={activeTab} onSelect={handleTabChange}>
              {videos.map((video, index) => (
                <Tab eventKey={video.eventKey} key={index} title={video.title} className="col-lg-4 show_desktop">
                  <div className="" id={`step${video.id + 1}`}>
                    <div className="pr_card">
                      <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                        <div id="v-video" className="v-video">
                          <iframe
                            ref={(ref) => (playerRefs.current[video.id] = ref)}
                            src={video.url}
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen=""
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title={`Video-${video.id}`}
                            data-ready="true"
                          ></iframe>
                        </div>
                      </div>
                      <div className="pr_content tab-mobile-baar-title">
                        <h6>{video.step}</h6>
                        <h4>{video.name}</h4>
                        <p>{video.description}</p>


                        <div className="navigation-btn">
                          <button
                            className={`left-navigation-btn navigation-btn-item ${activeTab === tabKeys[0] ? 'disabled' : ''}`}
                            onClick={handlePrevTab}
                          >
                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                              width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                              preserveAspectRatio="xMidYMid meet">

                              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                fill="#ffffff" stroke="none">
                                <path d="M1405 3824 c-47 -25 -1143 -1123 -1167 -1169 -28 -54 -28 -136 0
                                -190 30 -59 1126 -1150 1174 -1170 176 -72 358 111 279 280 -13 26 -143 163
                                -380 400 -199 198 -361 363 -361 367 0 5 857 8 1903 8 l1904 0 44 23 c68 36
                                103 93 107 175 4 81 -21 138 -81 186 l-39 31 -1919 3 c-1055 1 -1919 6 -1919
                                10 0 4 164 171 365 372 394 394 403 405 393 494 -7 60 -50 130 -100 163 -51
                                34 -155 43 -203 17z"/>
                              </g>
                            </svg>
                          </button>


                          <button
                            className={`right-navigation-btn navigation-btn-item ${activeTab === tabKeys[tabKeys.length - 1] ? 'disabled' : ''}`}
                            onClick={handleNextTab}
                          >
                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                              width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                              preserveAspectRatio="xMidYMid meet">

                              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                fill="#ffffff" stroke="none">
                                <path d="M3535 3821 c-104 -47 -153 -175 -106 -276 13 -26 143 -163 380 -400
                              199 -198 361 -363 361 -367 0 -5 -857 -8 -1903 -8 l-1904 0 -44 -23 c-68 -36
                              -103 -93 -107 -175 -4 -81 21 -138 81 -186 l39 -31 1919 -3 c1055 -1 1919 -6
                              1919 -10 0 -4 -164 -171 -365 -372 -394 -394 -403 -405 -393 -494 7 -60 50
                              -130 100 -163 56 -37 148 -44 204 -15 50 26 1145 1124 1170 1172 24 49 23 134
                              -4 185 -30 59 -1126 1150 -1174 1170 -50 20 -124 19 -173 -4z"/>
                              </g>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              ))}
            </Tabs>
          </div>


          {/* Slider view new code */}

          <div className="hide_mobile">
            <Swiper
              modules={[Scrollbar, Mousewheel]}
              spaceBetween={30}
              slidesPerView={1}
              onSlideChange={() => console.log('slide change')}
              onSwiper={(swiper) => console.log(swiper)}
              scrollbar={{ draggable: true }}
              mousewheel={{ forceToAxis: true }}
              breakpoints={{
                500: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
              }}
              className="our_process_slider"
            >
              {videos.map((video, index) => (
                <SwiperSlide key={index}>
                  <div className="tab-pane fade show_desktop show">
                    <div className="" id={`step${video.id + 1}`}>
                      <div className="pr_card">
                        <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                          <div id="v-video" className="v-video">
                            <iframe
                              ref={(ref) => (playerRefs.current[video.id] = ref)}
                              src={video.url}
                              frameborder="0"
                              allow="autoplay; fullscreen; picture-in-picture"
                              allowfullscreen=""
                              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                              title={`Video-${video.id}`}
                              data-ready="true"
                            ></iframe>
                          </div>
                        </div>
                        <div className="pr_content">
                          <h6>{video.step}</h6>
                          <h4>{video.name}</h4>
                          <p>{video.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>


          {/* <div className="gs_b d-flex show_tab_f align-items-center justify-content-between">
            <div className="gab_title">
              <div className="gab_icon ">
                <FaFingerprint />
              </div>
              <div className="gab_text">
                <h5>Get Started</h5>
                <small>Assessment</small>
              </div>
            </div>
            <a href="#" className="gab_action btn btn_default bg-white text-dark">Book now for: $49</a>
          </div> */}
          <div className="btn-section hide_desktop-v2">
            <ButtonList subject="club fitting"/>
          </div>
        </div>
      </section>


      <section id="image-scroll" className="bg_dark pt-0 pattern_bg_pattern">
        <div className="row">
          <div className="image-scroll">
            <div className="image-scroll-container">
              {/* <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView="auto"
                freeMode={true}
                loop={true}
                mousewheel={{ forceToAxis: true }}
                scrollbar={{ el: '.swiper-scrollbar', hide: true }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                className="swiper mySwiper_img"
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                speed={2000}

              >
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosTitleist.png')} alt="image1" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosTaylorMade.png')} alt="image2" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosSrixon.png')} alt="image3" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosScottyCameron.png')} alt="image4" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosProjectX.png')} alt="image5" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosPING.png')} alt="image6" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosMizuno.png')} alt="image7" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosLAGolf.png')} alt="image8" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosLABGolf.png')} alt="image9" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosKBS.png')} alt="image10" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosFujikura.png')} alt="image11" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosForeward.png')} alt="image12" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosFinedTuned.png')} alt="image13" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="patner_w_slide">
                  <div className="image-scroll-item-logo">
                    <img src={require('../../assets/images/Partners/forewardAccountLogosCallaway.png')} alt="image14" />
                  </div>
                </SwiperSlide>
              </Swiper> */}
              <div className="marquee-parent">
                <div className="marquee-content-item">
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo patner_1" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosTitleist.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosTitleist.png')} alt="image1" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosTaylorMade.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosTaylorMade.png')} alt="image2" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosSrixon.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosSrixon.png')} alt="image3" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosScottyCameron.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosScottyCameron.png')} alt="image4" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosProjectX.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosProjectX.png')} alt="image5" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosPING.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosPING.png')} alt="image6" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosMizuno.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosMizuno.png')} alt="image7" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosLAGolf.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosLAGolf.png')} alt="image8" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosLABGolf.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosLABGolf.png')} alt="image9" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosKBS.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosKBS.png')} alt="image10" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosFujikura.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosFujikura.png')} alt="image11" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosForeward.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosForeward.png')} alt="image12" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosFinedTuned.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosFinedTuned.png')} alt="image13" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosCallaway.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosCallaway.png')} alt="image14" /> */}
                    </div>
                  </div>




                  <div className="marquee-item">
                    <div className="image-scroll-item-logo patner_1" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosTitleist.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosTitleist.png')} alt="image1" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosTaylorMade.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosTaylorMade.png')} alt="image2" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosSrixon.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosSrixon.png')} alt="image3" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosScottyCameron.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosScottyCameron.png')} alt="image4" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosProjectX.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosProjectX.png')} alt="image5" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosPING.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosPING.png')} alt="image6" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosMizuno.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosMizuno.png')} alt="image7" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosLAGolf.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosLAGolf.png')} alt="image8" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosLABGolf.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosLABGolf.png')} alt="image9" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosKBS.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosKBS.png')} alt="image10" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosFujikura.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosFujikura.png')} alt="image11" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosForeward.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosForeward.png')} alt="image12" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosFinedTuned.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosFinedTuned.png')} alt="image13" /> */}
                    </div>
                  </div>
                  <div className="marquee-item">
                    <div className="image-scroll-item-logo" style={{ backgroundImage: `url(${require('../../assets/images/Partners/forewardAccountLogosCallaway.png')})` }}>
                      {/* <img src={require('../../assets/images/Partners/forewardAccountLogosCallaway.png')} alt="image14" /> */}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default OurProcess;

